import * as t from 'io-ts';
import { NonEmptyString } from 'io-ts-types';
import { fromEnum } from '../../responseUtil';
import { OptionalAddressCodec } from '../address.types';
import { ApiServiceType } from './serviceTypesApi.types';
import { ServiceVehicleCodec } from './serviceVehicleApi.types';

export enum ApiServiceOptionStatus {
    OPEN = 'open',
    CLOSED = 'closed',
    CANCELLED = 'cancelled',
}

export enum ServiceOptionApiSort {
    ORDER_ISSUED_AT_ASC = '+order_issued_at',
    ORDER_ISSUED_AT_DESC = '-order_issued_at',
    LOCATION_IDENTIFIER_ASC = '+location_identifier',
    LOCATION_IDENTIFIER_DESC = '-location_identifier',
    STATUS_ASC = '+status',
    STATUS_DES = '-status',
}

// eslint-disable-next-line @typescript-eslint/no-unused-vars
const ServiceOptionQueryParameterCodec = t.partial({
    statuses: t.array(fromEnum<ApiServiceOptionStatus>('ApiServiceOptionStatus', ApiServiceOptionStatus)),
    service_types: t.array(fromEnum<ApiServiceType>('ApiServiceType', ApiServiceType)),
    order_issued_at_after: t.string,
    order_issued_at_before: t.string,
    service_location: t.string,
    q: t.string,
    sort: fromEnum<ServiceOptionApiSort>('ServiceOptionApiSort', ServiceOptionApiSort),
    limit: t.number,
});

const ServiceOptionServiceCodec = t.intersection([
    t.type({
        type: fromEnum<ApiServiceType>('ApiServiceType', ApiServiceType),
        execution_count: t.number,
    }),
    t.partial({
        description: NonEmptyString,
    }),
]);

export type ApiServiceOptionService = t.TypeOf<typeof ServiceOptionServiceCodec>;

const ServiceOptionLocationCodec = t.intersection([
    t.type({
        identifier: t.string,
        time_zone: t.string,
    }),
    t.partial({
        address: OptionalAddressCodec,
    }),
]);

export type ApiServiceOptionLocation = t.TypeOf<typeof ServiceOptionLocationCodec>;

const ServiceOptionCodec = t.type({
    id: NonEmptyString,
    external_order_id: NonEmptyString,
    status: fromEnum<ApiServiceOptionStatus>('ApiServiceOptionStatus', ApiServiceOptionStatus),
    vehicle: ServiceVehicleCodec,
    order_issued_at: t.string,
    services: t.array(ServiceOptionServiceCodec),
    service_location: ServiceOptionLocationCodec,
});

export type ApiServiceOption = t.TypeOf<typeof ServiceOptionCodec>;

export const ServiceOptionPageCodec = t.type({
    items: t.array(ServiceOptionCodec),
    has_more: t.boolean,
});

export type ApiServiceOptionPage = t.TypeOf<typeof ServiceOptionPageCodec>;
export type ApiServiceOptionQueryParameter = t.TypeOf<typeof ServiceOptionQueryParameterCodec>;
